import EditorHandle from '../actors/editorHandle'

export default class ObstacleEditor {
  constructor (scene, editable) {
    this.scene = scene

    this.editable = editable

    this.handlers = []
    // this.addHandler(editable.image.x - editable.width * 0.5, editable.image.y, (x, y) => { this.setLeft(x) })
    // this.addHandler(editable.image.x + editable.width * 0.5, editable.image.y, (x, y) => { this.setRight(x) })
    // this.addHandler(editable.image.x, editable.image.y - editable.height * 0.5, (x, y) => { this.setTop(y) })
    this.addHandler(editable.image.x, editable.image.y + editable.height/* * 0.5 */, (x, y) => { this.setBottom(y) })
  }

  showHandlers () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].show()
    }
  }

  hideHandlers () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].hide()
    }
  }

  addHandler (x, y, callback) {
    var handler = new EditorHandle(this.scene, x, y, this, callback, 'editor_down')
    this.scene.add.existing(handler)
    this.handlers.push(handler)
  }

  refreshHandlerPositions () {
    // this.handlers[0].image.x = this.editable.image.x - this.editable.width * 0.5
    // this.handlers[0].image.y = this.editable.image.y
    // this.handlers[1].image.x = this.editable.image.x + this.editable.width * 0.5
    // this.handlers[1].image.y = this.editable.image.y
    // this.handlers[2].image.x = this.editable.image.x
    // this.handlers[2].image.y = this.editable.image.y - this.editable.height * 0.5
    this.handlers[0].image.x = this.editable.image.x
    this.handlers[0].image.y = this.editable.image.y + this.editable.height// * 0.5
  }

  // setTop (y) {
  //   var top = this.editable.image.y - (this.editable.height * 0.5)
  //   var btm = this.editable.image.y + (this.editable.height * 0.5)
  //   var diff = top - y

  //   this.editable.height += diff
  //   this.editable.image.y = btm - (this.editable.height * 0.5)

  //   this.editable.image.setScale(this.editable.width, this.editable.height)
  //   this.editable.onEdit()
  // }

  setBottom (y) {
    var top = this.editable.image.y - (this.editable.height)// * 0.5)
    var btm = this.editable.image.y + (this.editable.height)// * 0.5)
    var diff = y - btm

    this.editable.height += diff
    // this.editable.image.y = top + (this.editable.height * 0.5)

    // this.editable.image.setScale(this.editable.width, this.editable.height)
    this.editable.onEdit()
  }

  // setLeft (x) {
  //   var left = this.editable.image.x - (this.editable.width * 0.5)
  //   var right = this.editable.image.x + (this.editable.width * 0.5)
  //   var diff = left - x

  //   this.editable.width += diff
  //   this.editable.image.x = right - (this.editable.width * 0.5)

  //   this.editable.image.setScale(this.editable.width, this.editable.height)
  //   this.editable.onEdit()
  // }

  // setRight (x) {
  //   var left = this.editable.image.x - (this.editable.width * 0.5)
  //   var right = this.editable.image.x + (this.editable.width * 0.5)
  //   var diff = x - right

  //   this.editable.width += diff
  //   this.editable.image.x = left + (this.editable.width * 0.5)

  //   this.editable.image.setScale(this.editable.width, this.editable.height)
  //   this.editable.onEdit()
  // }

  delete () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].delete()
    }
  }
}
